"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ArrowDoubleDown;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ArrowDoubleDown(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "arrow-double-down"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M47.61,62.819a3.384,3.384,0,0,0,4.78,0L91.77,23.441a2.5,2.5,0,0,0-3.536-3.536L50,58.137,11.766,19.905A2.5,2.5,0,0,0,8.23,23.44Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M88.234,36.927,50,75.158,11.766,36.926A2.5,2.5,0,0,0,8.23,40.461L47.61,79.84a3.384,3.384,0,0,0,4.78,0L91.77,40.463a2.5,2.5,0,0,0-3.536-3.536Z"
  })))));
}